import axios from '@/libs/axios';
import { ErrorMessage } from '@/libs/Error';

export default class SLSImagemHomeClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async getImagemHome(queries = {}) {
    try {
      const { data } = await this.api.get('/imagem-home', { params: queries });
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as imagens da home');
    }
  }

  async postImagemHome(imagemHome) {
    try {
      return await this.api.post('/imagem-home', imagemHome, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    } catch (error) {
      throw this.error.message(error, 'Erro ao salvar a imagem da home');
    }
  }

  async getImagemHomeById(id) {
    try {
      const { data } = await this.api.get(`/imagem-home/${id}`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar a imagem da home');
    }
  }

  async putImagemHome(id, imagemHome) {
    try {
      return await this.api.put(`/imagem-home/${id}`, imagemHome, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    } catch (error) {
      throw this.error.message(error, 'Erro ao atualizar a imagem da home');
    }
  }

  async deleteImagemHome(id) {
    try {
      return await this.api.delete(`/imagem-home/${id}`);
    } catch (error) {
      throw this.error.message(error, 'Erro ao excluir a imagem da home');
    }
  }

  async deleteImagemHomeSoftDelete(id) {
    try {
      return await this.api.delete(`/imagem-home/${id}/softDelete`);
    } catch (error) {
      throw this.error.message(error, 'Erro ao excluir a imagem da home');
    }
  }
}
